import { Calendar, Col, Row, Spin } from 'antd';
import moment, { Moment } from 'moment';
import { formatTime, I18nt } from 'utils';
import styles from './dateView.module.less';
import { useAgendarCita } from 'pages/AgendarCita/AgendarCitaContext';
import cn from 'classnames';
import { useEffect } from 'react';

const PlaceView = () => {
	const {
		schedules,
		onDatePick,
		setTime,
		selectedTime,
		selectedClinic,
		isFormLoading,
		isDateTouched,
		selectedDate,
	} = useAgendarCita();

	useEffect(() => {
		onDatePick({
			establecimiento: selectedClinic?.idEstablecimiento,
			fecha: moment().add('days', 1).format('YYYY-MM-DD'),
		});
	}, []);

	const handleDateClick = (value: Moment) => {
		onDatePick({
			establecimiento: selectedClinic?.idEstablecimiento,
			fecha: value.format('YYYY-MM-DD'),
		});
	};

	const disabledDate = (date: Moment) => {
		if (date.days() === 0) {
			return true;
		}
		const today = new Date().getTime();
		const currentDate = date.toDate().getTime();
		return currentDate < today;
	};

	const getAvailableSchedules = () => {
		if (moment().format('YYYY-MM-DD') > (selectedDate || '')) {
			return [];
		}
		return schedules;
	};

	const availableSchedules = getAvailableSchedules();

	return (
		<Row justify='center'>
			<Col xs={24} lg={18} xl={14} xxl={12}>
				<section className={styles.dateSection}>
					<Row>
						<Col xs={24} lg={12}>
							<div>
								<div className={styles.title}>
									{selectedClinic?.establecimiento.toLocaleLowerCase()}
								</div>
								<div className={styles.dateContainer}>
									<Calendar
										defaultValue={moment().add('days', 1)}
										disabledDate={disabledDate}
										onChange={handleDateClick}
									/>
								</div>
							</div>
						</Col>
						<Col xs={24} lg={12}>
							<div>
								<div className={styles.scheduleTitle}>
									{I18nt('hora_disponible')}
								</div>
								<div className={styles.scheduleContainer}>
									{isFormLoading ? (
										<div className={styles.spinCont}>
											<Spin />
										</div>
									) : (
										availableSchedules.map((schedule) => (
											<button
												onClick={() => setTime(schedule)}
												key={schedule}
												className={cn(styles.schedule, {
													[styles.scheduleActive]:
														selectedTime === schedule.slice(0, 5),
												})}
											>
												{formatTime(schedule)}
											</button>
										))
									)}
									<p className={styles.feedbackText}>
										{isDateTouched && availableSchedules.length === 0
											? I18nt('sin_horarios')
											: !(availableSchedules.length > 0)
											? I18nt('seleccionar_hora')
											: null}
									</p>
								</div>
							</div>
						</Col>
					</Row>
				</section>
			</Col>
		</Row>
	);
};

export default PlaceView;
